import { useEffect, useState } from 'react';

import { supabase } from '../lib/supabase';
import { useMyRestaurants } from './useMyRestaurants';

export interface Caps {
  ops: boolean;       // salão: comandas/pedidos/pagamento/bar (owner/manager/waiter)
  kitchen: boolean;   // cozinha (owner/manager/kitchen)
  queue: boolean;     // fila/hostess (owner/manager/hostess/waiter)
  admin: boolean;     // config/cardápio/CRM/equipe (owner/manager)
  finance: boolean;   // assinatura (owner ou manager c/ can_finance)
  master: boolean;    // plataforma
}

const has = (role: string | null, roles: string[]) => !!role && roles.includes(role);

/**
 * Papel + capacidades do usuário no restaurante atual (espelha os helpers de RLS).
 * O frontend usa isto só para nav/rotas; a trava real continua no banco.
 */
export function useRole() {
  const { restaurants, loading } = useMyRestaurants();
  const [isMaster, setIsMaster] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let active = true;
    void supabase.rpc('is_master').then(({ data }) => {
      if (active) { setIsMaster(Boolean(data)); setChecked(true); }
    });
    return () => { active = false; };
  }, []);

  const r = restaurants[0];
  const role = r?.role ?? null;
  const canFinance = Boolean(r?.can_finance);
  const expiresAt = r?.expires_at ?? null;
  const m = isMaster;

  const caps: Caps = {
    ops: m || has(role, ['owner', 'manager', 'waiter']),
    kitchen: m || has(role, ['owner', 'manager', 'kitchen']),
    queue: m || has(role, ['owner', 'manager', 'hostess', 'waiter']),
    admin: m || has(role, ['owner', 'manager']),
    finance: m || role === 'owner' || (role === 'manager' && canFinance),
    master: m
  };

  return { role, canFinance, isMaster: m, isTemp: !!expiresAt, expiresAt, caps, loading: loading || !checked };
}
